// @flow

import React from "react";

import { IoIosWarning } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { Modal, OkButton, useModal } from "@quantum/ui";
import { Translate } from "@quantum/i18n";

import "./modal-erro-adicionar-medida.css";

const ModalErroAdicionarMedida = () => {
  const { close, isOpen } = useModal("erro-adicionar-medida");

  return (
    <Modal
      show={isOpen}
      className="ModalErroAdicionarMedida"
      header={onHide => (
        <div className="ModalErroAdicionarMedida__header">
          <div
            className="ModalErroAdicionarMedida__header-fechar"
            onClick={onHide}
          >
            <MdClose />
          </div>
        </div>
      )}
      onHide={close}
    >
      <div className="ModalErroAdicionarMedida__mensagem">
        <IoIosWarning />
        <Translate>
          configuracaoRelatorio.adicionarMedida.erroAdicionar
        </Translate>
      </div>
      <div className="ModalErroAdicionarMedida__botoes">
        <OkButton onClick={close}>Ok</OkButton>
      </div>
    </Modal>
  );
};

export default ModalErroAdicionarMedida;
